import { render, staticRenderFns } from "./equipment.vue?vue&type=template&id=6866c890&scoped=true"
import script from "./equipment.vue?vue&type=script&lang=js"
export * from "./equipment.vue?vue&type=script&lang=js"
import style0 from "./equipment.vue?vue&type=style&index=0&id=6866c890&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6866c890",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6866c890')) {
      api.createRecord('6866c890', component.options)
    } else {
      api.reload('6866c890', component.options)
    }
    module.hot.accept("./equipment.vue?vue&type=template&id=6866c890&scoped=true", function () {
      api.rerender('6866c890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/equipment.vue"
export default component.exports